require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-fleet-premium-elite.json") })
        }
      }, "path---es-fleet-premium-elite");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-fleet-premium-elite!./.cache/json/es-fleet-premium-elite.json
// module id = 1089
// module chunks = 231608221292675